export const REDUX_ACTIONS = {
      // dataObjectReducer
      TOGGLE: "toggle",
      SEARCH: "search"
}